








































import { Vue, Component, Prop } from 'vue-property-decorator';
import type { User } from '@/core/admin/models/User';
import DialogTitle from '@/ui/components/atoms/textItems/DialogTitle.vue';
import { AlertStoreActions, AlertType } from '@/ui/stores/AlertStore';
import ButtonWithText from '@/ui/components/atoms/buttons/ButtonWithText.vue';
import ImportCampaignForm from '@/ui/components/organisms/forms/ImportCampaignForm.vue';
import { importCampaignUseCase } from '@/core/campaign/usecases/importCampaignUseCase';
import { ImportCampaignDTO } from '@/core/campaign/DTO/ImportCampaignDTO';
import getLogger from '@/shared/logger/logger';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = getLogger('ImportCampaignForm');

@Component({
  name: 'ImportCampaignDialog',
  components: { ImportCampaignForm, ButtonWithText, DialogTitle },
})
export default class ImportCampaignDialog extends Vue {
  @Prop({ type: Boolean }) showDialog!: boolean;
  private triggerSaveNewOnForm = false;
  private isLoading = false;

  get currentUser(): User {
    return this.$store.state.userStore.currentUser;
  }

  async importCampaignValidInput(importCampaignDTO: ImportCampaignDTO) {
    this.isLoading = true;
    importCampaignUseCase(importCampaignDTO, this.currentUser)
      .then(() => {
        this.closeDialog();
        this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
          message: 'campaign.import-campaign.success',
          type: AlertType.SUCCESS,
        });
        this.$emit('created');
      })
      .catch((error: unknown) => {
        LOG.error('error importing campaign', error);
        this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
          message: 'campaign.import-campaign.error',
          type: AlertType.ERROR,
        });
      })
      .finally(() => {
        this.triggerSaveNewOnForm = false;
        this.isLoading = false;
      });
  }

  importCampaign() {
    this.triggerSaveNewOnForm = true;
  }

  handleInvalidInput() {
    this.triggerSaveNewOnForm = false;
  }

  closeDialog() {
    this.$emit('close');
    this.clearInput();
  }

  clearInput() {
    const ref = this.$refs.importCampaignForm as ImportCampaignForm;
    ref.clearInput();
  }
}
